var n=function(n,r){return null==n?void 0:n[r]};export{n as default};
//# sourceMappingURL=_getValue.js.map
